import { cn } from "@/lib/utils"
import { t } from "@/lib/i18n"

/**
 * The promise the diner-facing landing made, restated in the same words.
 *
 * The headline is literally `ui.landing.hero.primary_cta` ("Crea tu
 * restaurante") because every CTA that reaches this page says exactly that.
 * The page used to open with "Crea una cuenta de staff", which broke the
 * promise at the point of highest friction and hid the fact that
 * Staff::RegistrationsController sends a fresh account straight on to
 * `new_staff_location_path`.
 */
export function RegistrationIntro({ className }: { className?: string }) {
  return (
    <div className={cn("flex flex-col gap-5", className)}>
      <span className="flex w-fit items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium text-muted-foreground">
        <span className="size-2 rounded-full bg-foreground" aria-hidden />
        {t("ui.react.pages.staff.registrations.new.step_badge")}
      </span>

      <h1
        className="text-balance text-3xl font-bold leading-[1.08] tracking-tight sm:text-4xl"
        data-testid="staff-registration-title"
      >
        {t("ui.react.pages.staff.registrations.new.title")}
      </h1>

      <p className="max-w-xl text-pretty text-base leading-7 text-muted-foreground">
        {t("ui.react.pages.staff.registrations.new.subtitle")}
      </p>
    </div>
  )
}
